import { Col, Modal, ModalBody, ModalHeader, Row } from 'reactstrap';
import { Button } from 'edozvola-frontend-lib/dist/ui';
import React from 'react';
import { FullScreenLoader } from 'app/shared/loader/fullscreen-loader';

export interface IDigitalSignatureProps {
  isModalOpen: boolean;
  setModalOpen: (isOpen: boolean) => void;
  signLoading?: boolean;
  onSignAKD: () => void;
  onSignFINA: () => void;
}

const DigitalSignatureModal = (props: IDigitalSignatureProps) => {
  return (
    <Modal centered contentClassName="rounded" isOpen={props.isModalOpen} size="md">
      {props.signLoading && <FullScreenLoader />}
      <ModalHeader className="d-flex">
        <span>Digitalni potpis</span>
      </ModalHeader>
      <ModalBody>
        <Row>
          <p>Odaberite digitalni potpis kojim želite potpisati dokument:</p>
        </Row>
        <Row className="mt-4">
          <Col xs={3}>
            <Button label="Odustani" outline onClick={() => props.setModalOpen(false)} />
          </Col>
          <Col xs={9}>
            <Row>
              <Col xs={7}></Col>
              <Col xs={2}>
                <Button color="info" label="AKD" onClick={props.onSignAKD} />
              </Col>
              <Col xs={3}>
                <Button color="info" label="FINA" onClick={props.onSignFINA} />
              </Col>
            </Row>
          </Col>
        </Row>
      </ModalBody>
    </Modal>
  );
};

export default DigitalSignatureModal;
